// TODO: export to separate module?
const createLogger = (namespace) => ({
  trace: (...args) => console.trace(`[${namespace}:trace]`, ...args),
  debug: (...args) => console.debug(`[${namespace}:debug]`, ...args),
  log: (...args) => console.log(`[${namespace}]`, ...args),
  info: (...args) => console.info(`[${namespace}:info]`, ...args),
  warn: (...args) => console.warn(`[${namespace}:warn]`, ...args),
  error: (...args) => console.error(`[${namespace}:error]`, ...args),
})

export default createLogger
